import LoadMorePagination from '../../../container/pagination/LoadMorePagination';

import type { HydraViewExtended } from '@vs-shop/schemas/openapi/hydraView';

type Props = {
  isLoading?: boolean;
  hydraViewExtended: HydraViewExtended;
  loadMorePages: () => void;
};

export default function ArticlesLoadNextPage({
  hydraViewExtended,
  loadMorePages,
  isLoading = false,
}: Props) {
  return (
    <LoadMorePagination
      hydraViewExtended={hydraViewExtended}
      loadMorePages={loadMorePages}
      isLoading={isLoading}
    />
  );
}
